import { render } from "./que1.vue?vue&type=template&id=2be03de8"
import script from "./que1.vue?vue&type=script&lang=js"
export * from "./que1.vue?vue&type=script&lang=js"

import exportComponent from "/Users/chenjun/Desktop/myProject/pbl-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__